import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DefaultReportFormatContentPayload} from './defaultReportFormatContent.payload';
import {
    AbstractActionNoCacheService
} from '../../../../../core/service/v2/service/action/abstractActionNoCache.service';

@Injectable()
export class DefaultReportActionFormatContentService extends AbstractActionNoCacheService<DefaultReportFormatContentPayload, any> {

    public constructor(httpClient: HttpClient) {
        super('v1/reports', 'format-content', httpClient);
    }

    buildOptions(payload: DefaultReportFormatContentPayload): any {
        return {
            responseType: 'text',
        };
    }
}
